<template>
  <header ref="headerRef" class="sticky top-0 z-50 w-full bg-white">
    <!-- <div class="w-full h-1 bg-gradient-to-r from-thenti-100 to-thenti-900"></div> -->
    <div
      class="w-full mx-auto text-black items-center pt-1 pb-1 bg-white md:container md:flex md:justify-between text-xl">
      <div class="flex justify-between items-center h-16 px-4">
        <router-link to="/">
          <img src="/img/logo.svg" class="h-10" alt="logo" />
        </router-link>
        <button @click="$emit('toggleMenu')" class="md:hidden relative">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" :class="!isOpen ? 'block' : 'hidden'"
            @click="isOpen = true" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
          </svg>

          <svg class="w-10 h-10" :class="isOpen ? 'block' : 'hidden'" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" @click="isOpen = false">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>

        </button>
      </div>

      <!-- 🖥️ Desktop Navigation -->
      <div class="hidden md:flex md:items-center md:space-x-8">
        <HoverDropdown :label="$t('common.technology')" :links="[
          { to: '/technology/documents', label: $t('common.documents') },
          { to: '/technology/luxury_items', label: $t('common.luxury_objects') },
          { to: '/technology/personnel', label: $t('common.critical_personnel') }
        ]" />
        <HoverDropdown :label="$t('common.usecases')" :links="[
          { to: '/uses/industry', label: $t('common.industry') },
          // { to: '/uses/research', label: $t('common.research') }
        ]" />
        <HoverDropdown :label="$t('common.company')" :links="[
          { to: '/company/about', label: $t('common.about_us') },
          { to: '/company/careers', label: $t('common.join_us') },
          { to: '/company/contact', label: $t('common.contact') }
        ]" />
        
      </div>
      <div class="hidden md:block">
        <LanguageSwitcher />
      </div>
      <!-- <div class="hidden md:flex md:flex-row md:items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="w-10 h-10 bg-gradient-to-r from-thenti-100 to-thenti-900 rounded-full text-white"
          viewBox="0 0 16 12"
        >
          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
        </svg>
        <span className="font-bold text-xl pt-1 pb-2 px-2">Log in</span>
      </div> -->
    </div>
    <div class="w-full h-1 bg-gradient-to-r from-thenti-100 to-thenti-900"></div>
  </header>
</template>

<script lang="ts">
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import DarkModeToggle from '../DarkModeToggle.vue';
import HoverDropdown from '../header/HoverDropdown.vue';
import MobileDropdown from '../header/MobileDropdown.vue';

import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'SiteHeader',
  components: { LanguageSwitcher, DarkModeToggle, HoverDropdown, MobileDropdown },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
});
</script>
